import adminRequest from '../../adminRequest'
import {customerService} from '../../endpoints'

export default class customerApi {
  static async customerInfo(data) {
    return adminRequest({
      url: customerService.customerInfo,
      method: 'POST',
      data: JSON.stringify(data),
    })
  }
}
